import { useEffect, useId, useRef } from "react";
import { Field } from "@carepass/ui";

/** The first seven digits only; the remaining six are never collected. */
export function PartnerIdentityNumber({ value, onChange, disabled = false }: {
  value: string; onChange: (value: string) => void; disabled?: boolean;
}) {
  const descriptionId = useId();
  const front = useRef<HTMLInputElement | null>(null);
  const rear = useRef<HTMLInputElement | null>(null);
  const focusRear = useRef(false);
  useEffect(() => {
    if (focusRear.current && value.length >= 6) { rear.current?.focus(); focusRear.current = false; }
  }, [value]);
  return <fieldset className="partner-onepage__identity" disabled={disabled} aria-describedby={descriptionId}>
    <legend>주민등록번호 앞 7자리</legend>
    <div className="partner-onepage__identity-row">
      <Field ref={el => { front.current = el as HTMLInputElement | null; }} label="생년월일 6자리" required inputMode="numeric" autoComplete="off" maxLength={6} placeholder="생년월일 6자리" value={value.slice(0, 6)} onChange={event => {
        const birth = event.currentTarget.value.replace(/\D/g, "").slice(0, 6);
        focusRear.current = birth.length === 6;
        onChange(birth + (birth.length === 6 ? value.slice(6, 7) : ""));
      }} />
      <span aria-hidden="true">−</span>
      <Field ref={el => { rear.current = el as HTMLInputElement | null; }} className="partner-onepage__identity-digit" label="뒷자리 첫 숫자" required inputMode="numeric" autoComplete="off" maxLength={1} placeholder="1자리" disabled={disabled || value.length < 6} value={value.slice(6, 7)} onChange={event => onChange(value.slice(0, 6) + event.currentTarget.value.replace(/\D/g, "").slice(0, 1))} onKeyDown={event => { if (event.key === "Backspace" && !value.slice(6)) front.current?.focus(); }} />
      <span className="partner-onepage__masked" aria-hidden="true">{Array.from({ length: 6 }, (_, index) => <i key={index} />)}</span>
    </div>
    <p id={descriptionId}>생년월일 6자리와 뒷자리 첫 숫자만 입력해 주세요. 결제 인증 요청에만 사용하며 저장하지 않습니다.</p>
  </fieldset>;
}
